import { serializeTokens } from './tokens'
import { SerializedFarmConfig } from './types'

const serializedTokens = serializeTokens()

const farms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 1, 2) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'NCXX',
    lpAddresses: {
      97: '0x9C21123D94b93361a29B2C2EFB3d5CD8B17e0A9e',
      1: '0x7F2c575cd950d6EefDC291cc9B143DCD6F0652dd',
    },
    token: serializedTokens.syrup,
    quoteToken: serializedTokens.weth,
  },
  {
    pid: 1,
    lpSymbol: 'NCXX-ETH LP',
    lpAddresses: {
      97: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
      1: '0x1807b4e71b661E283c51F43852B8B7486b692599',
    },
    token: serializedTokens.cake,
    quoteToken: serializedTokens.weth,
  },
  {
    pid: 2,
    lpSymbol: 'BUSD-ETH LP',
    lpAddresses: {
      97: '',
      1: '0xF4fC6F191a647846b26A0860DCb537616ACE7419',
    },
    token: serializedTokens.usdc,
    quoteToken: serializedTokens.weth,
  },
 
  /**
   * V3 by order of release (some may be out of PID order due to multiplier boost)
   */
  
]

export default farms
